import React, { ReactElement } from 'react'

import { OrderState } from './types'

type OverallStateProps = {
  state?: OrderState
}

export const OverallState = (props: OverallStateProps): ReactElement => {
  const { state } = props

  const label = getState(state)

  return (
    <>
      <span>{label || i18n.t('unknown', 'Unbekannt')}</span>
    </>
  )
}

export function getStates(): Record<OrderState, string> {
  return {
    delivered: i18n.t('status_delivered', 'Zugestellt'),
    deliveryIssue: i18n.t('status_delivery_issue', 'Zustellprobleme'),
    onTheWay: i18n.t('status_on_the_way', 'Unterwegs'),
    pickupIssue: i18n.t('status_pickup_issue', 'Abholprobleme'),
    created: i18n.t('status_created', 'Erfasst'),
    negative: i18n.t('status_negative', 'Negativereignisse'),
  }
}

export function getState(state?: OrderState): string | undefined {
  if (!state) return undefined
  return getStates()[state]
}
